import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";

export class AdhesiveBridge extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    const resolvedConditions = [
      "wear",
      "caries",
      "restoration",
      "veneer",
      "crown",
      "onlay",
      "denture",
      "bridge",
      "adhesive-bridge",
    ];

    const mesialTeeth = [];
    const distalTeeth = [];

    let upperArch = Array.apply(null, Array(16));
    upperArch = upperArch.map((val, i) => {
      const number = i < 8 ? 18 - i : i + 13;
      const apply = item.teeth.includes(number);
      return {
        number: number,
        applied: apply,
        extra: !apply,
      };
    });
    // add extra
    upperArch.forEach((tooth, i) => {
      if (i < 15 && upperArch[i + 1].applied && !upperArch[i + 1].extra) {
        upperArch[i].applied = true;
      }
      if (i > 0 && upperArch[i - 1].applied && !upperArch[i - 1].extra) {
        upperArch[i].applied = true;
      }
    });

    let lowerArch = Array.apply(null, Array(16));
    lowerArch = lowerArch.map((val, i) => {
      const number = i < 8 ? 48 - i : i + 23;
      const apply = item.teeth.includes(number);
      return {
        number: number,
        applied: apply,
        extra: !apply,
      };
    });
    // add extra
    lowerArch.forEach((tooth, i) => {
      if (i < 15 && lowerArch[i + 1].applied && !lowerArch[i + 1].extra) {
        lowerArch[i].applied = true;
      }
      if (i > 0 && lowerArch[i - 1].applied && !lowerArch[i - 1].extra) {
        lowerArch[i].applied = true;
      }
    });

    upperArch.forEach((tooth, i) => {
      if (tooth.applied) {
        if (i > 0 && upperArch[i - 1].applied) {
          if (i <= 7) {
            distalTeeth.push(tooth.number);
          } else {
            mesialTeeth.push(tooth.number);
          }
        }
        if (i < 15 && upperArch[i + 1].applied) {
          if (i <= 7) {
            mesialTeeth.push(tooth.number);
          } else {
            distalTeeth.push(tooth.number);
          }
        }
      }
    });

    lowerArch.forEach((tooth, i) => {
      if (tooth.applied) {
        if (i > 0 && lowerArch[i - 1].applied) {
          if (i <= 7) {
            distalTeeth.push(tooth.number);
          } else {
            mesialTeeth.push(tooth.number);
          }
        }
        if (i < 15 && lowerArch[i + 1].applied) {
          if (i <= 7) {
            mesialTeeth.push(tooth.number);
          } else {
            distalTeeth.push(tooth.number);
          }
        }
      }
    });

    const extraTeeth = [
      ...upperArch
        .filter((tooth) => tooth.applied)
        .map((tooth) => tooth.number),
      ...lowerArch
        .filter((tooth) => tooth.applied)
        .map((tooth) => tooth.number),
    ];

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth, i) => {
        tooth.diagnosis = tooth.diagnosis.filter(
          (diagnosis) => !resolvedConditions.includes(diagnosis.condition),
        );
        tooth.plan.push({ treatment: item.treatment });
      });

    odontogram
      .filter((tooth) => extraTeeth.indexOf(tooth.number) > -1)
      .forEach((tooth, i) => {
        if (mesialTeeth.includes(tooth.number)) {
          tooth.plan.push({ treatment: item.treatment, options: "mesial" });
        }
        if (distalTeeth.includes(tooth.number)) {
          tooth.plan.push({ treatment: item.treatment, options: "distal" });
        }
      });

    return odontogram;
  }

  static getIdentifier(): string {
    return "adhesive-bridge";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/prostho/adhesive-bridge.ts